import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
export type ContentDetails_ContentAssetReferenceFragmentFragment = {
  __typename?: 'ContentAssetReference'
  id?: string | null
  asset?: {
    __typename?: 'Asset'
    id?: string | null
    mimeType?: string | null
    fileSize?: number | null
    originalFileName?: string | null
    renderUrl?: string | null
    contentAssetReference?: {
      __typename?: 'ContentAssetReference'
      assetsId?: string | null
    } | null
  } | null
}

export const ContentDetails_ContentAssetReferenceFragmentFragmentDoc = gql`
  fragment ContentDetails_ContentAssetReferenceFragment on ContentAssetReference {
    id
    asset {
      id
      mimeType
      contentAssetReference {
        assetsId
      }
      fileSize
      originalFileName
      renderUrl
    }
  }
`
